<template>
  <b-row v-if="videerror == true">
    <div
      class="fixed-top d-flex align-items-center justify-content-center"
      style="bottom: 0; overflow-y: auto"
    >
      <b-card bg-variant="#ffffff" class="shadow" text-variant="dark">
        <b-card-text>
          {{ message }}
        </b-card-text>
      </b-card>
    </div>
  </b-row>
  <Verification
    :education="link"
    @valid-patient="validatePatient"
    v-else-if="isAuthenticated == false"
    :DOBPresent="patientDOB !== undefined"
  />
  <b-col cols="12" v-else-if="isAuthenticated == true">
      <b-card-title class="pb-3 pt-2">{{
        currentVideo.videoName
      }}</b-card-title>
        <b-row class="justify-content-center">
          <b-col cols="12" :id="currentVideo.videoLink"> </b-col>
          <b-col cols="12" class="mt-2 center-block">
            {{ currentVideo.videoDescription }}
          </b-col>
          <div v-if="this.showAck">
            <b-col cols="12" class="mt-2 text-center">
              {{
                "By clicking this button, I acknowledge that I have watched the video in its entirety"
              }}
            </b-col>
            <b-col cols="12" class="mt-2 text-center">
              <b-button :disabled="isFinished" @click="acknowledge()" variant="primary"
                >{{buttonText}}</b-button
              >
            </b-col>
          </div>
        </b-row>

  </b-col>
</template>
<script>
import {
  FETCH_PATIENT_VIDEOS,
  ACKNOWLEDGE_VIDEO,
  RESET_STATE,
} from "@/store/actions.type";
import { SET_IS_LOADING } from "@/store/mutations.type";
import Verification from "@/views/patient/auth/Verification";
import store from "@/store";
export default {
  name: "PatientEducation",
  components: {
    Verification,
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch(RESET_STATE),
      store.commit(SET_IS_LOADING, true),
    ]).then(() => {
      store.commit(SET_IS_LOADING, false);
      next();
    });
  },
  computed: {
    videerror() {
      return this.error;
    },
    isAuthenticated() {
      return this.isAuthenticate;
    },
    currentVideo() {
      return this.currVideo;
    },
    link() {
      return this.$route.query.id;
    },
    patientDOB() {
      return this.$route.query.dob;
    }
  },
  data() {
    return {
      showAck:true,
      isAuthenticate: false,
      dob: null,
      videos: [],
      currVideo: {},
      currVideoIndex: 0,
      toastMessage: "",
      isFinished: false,
      message: "",
      error: false,
      buttonText: "Acknowlege"
    };
  },
  mounted() {
    this.$store.commit(SET_IS_LOADING, true);
    this.$store
      .dispatch(FETCH_PATIENT_VIDEOS, "education/" + this.$route.query.id)
      .then((resp) => {
        if (resp.status == 200) {
          this.videos = resp.data
          this.$store.commit(SET_IS_LOADING, false);
        } else {
          this.error = true;
          this.message = resp.data.errorMessage;
          this.$store.commit(SET_IS_LOADING, false);
        }
      });
  },
  methods: {
    acknowledge() {
      let completedVideo = this.videos[this.currVideoIndex];
      completedVideo.status = "COMPLETED";
      let responseObj = {
        dob: this.dob,
        educationLink: this.link,
        education: [completedVideo],
      };

      this.$store
        .dispatch(ACKNOWLEDGE_VIDEO, {
          slug: "education/acknowledge",
          params: responseObj,
        })
        .then((resp) => {
          if (resp.status) {
            if (this.currVideoIndex < (this.videos.length - 1)) {
              this.toastMessage = resp.data.message;
              this.showSuccessToast();
              this.currVideoIndex++;
              this.loadNextVideo();
            } else {
              this.toastMessage = resp.data.message;
              this.showSuccessToast();
              this.isFinished = true
              this.buttonText = "Video Acknowleged"
            }
          } else {
            this.error = true;
            this.message = resp.data;
          }
        });
      this.error = false;
    },
    loadNextVideo() {
      this.isAuthenticated = true;
      this.$loadScript("https://www.swarminteractive.com/js/vm.js")
        .then(() => {
          this.currVideo = this.videos[this.currVideoIndex];
          if (this.currVideo.status == 'COMPLETED') {
            this.showAck = false;
          }
          let scriptElement = document.createElement("script");
          scriptElement.setAttribute("type", "text/javascript");
          let b =
            "client='9017'; menuaccess=false; fullscreen=true; width=720; search=false; sections=false; disclaimer=true; openthis=" +
            "'" +
            this.currVideo.videoLink +
            "'" +
            ";vm_open();";
          scriptElement.innerText = b;
          document.head.appendChild(scriptElement);
        })
        .catch(() => {
          this.error = true;
          this.message =
            "Video not found.  Contact Admin if problem persists.";
        });
    },
    validatePatient(validationData) {
      this.dob = validationData.dob;
      this.isAuthenticate = true;
      if (this.videos.length > 0) {
        this.loadNextVideo();
      } else {
        this.toastMessage =
          "All videos watched and acknowledged. No action required";
        this.showSuccessToast();
      }
    },
    showSuccessToast() {
      this.$bvToast.toast(this.toastMessage, {
        title: "Success",
        variant: "success",
        autoHideDelay: 1500,
      });
    },
  },
};
</script>
